import { useCallback, useState } from 'react';

/** The open state of one menu, anchored to the control that opened it. */
export interface MenuAnchor {
    readonly anchorEl: HTMLElement | null;
    readonly open: boolean;
    /** Opens the menu under the given control. */
    readonly onOpen: (anchor: HTMLElement) => void;
    readonly onClose: () => void;
}

/**
 * Holds which control a menu is open from, if any. `onOpen` and `onClose`
 * keep their identity across renders, so a menu item can call `onClose`
 * after its own action without re-creating the handlers of every item.
 */
export function useMenuAnchor(): MenuAnchor {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const onOpen = useCallback(
        (anchor: HTMLElement) => setAnchorEl(anchor),
        []
    );
    const onClose = useCallback(() => setAnchorEl(null), []);
    return { anchorEl, open: anchorEl !== null, onOpen, onClose };
}
